import { Alpine } from "alpinejs";
import { alpineData } from "./alpine-data";

/**
 * Appointments shared logic
 */
export function registerAppointments(Alpine: any) {
  Alpine.data("appointmentForm", (initial: any = {}) => alpineData({
    form: {
      template_id: initial.template_id || "",
      title: initial.title || "",
      description: initial.description || "",
      location: initial.location || "",
      category: initial.category || "",
      duration_min: initial.duration_min || 60,
      start_time: initial.start_time || "",
      end_time: initial.end_time || "",
      project_ids: initial.project_ids || [],
    },

    init() {
      this.$watch("form.template_id", (value: string) => {
        if (value) {
          this.loadTemplate(value);
        }
      });
    },

    applyTemplate(id: string) {
      this.loadTemplate(id);
    },

    async loadTemplate(id: string) {
      try {
        const response = await fetch(`/api/appointment-templates/${id}`);
        if (response.ok) {
          const template = await response.json();

          // Update form fields from template
          if (template.title) this.form.title = template.title;
          if (template.description) this.form.description = template.description;
          if (template.location) this.form.location = template.location;
          if (template.category) this.form.category = template.category;
          if (template.duration_min) this.form.duration_min = template.duration_min;

          // Dispatch events for components to react (e.g. Combobox)
          this.$nextTick(() => {
            const inputs = this.$el.querySelectorAll("input, select, textarea");
            inputs.forEach((input: any) => {
              input.dispatchEvent(new Event("input", { bubbles: true }));
              input.dispatchEvent(new Event("change", { bubbles: true }));
            });
          });
        }
      } catch (err) {
        console.error("Failed to load appointment template:", err);
      }
    },
  }));
}
